$(function () {
	(function initMobHeaderMenu() {
		var $hbrBtn = $("#hbr-btn"),
			$header = $(".header");

		$hbrBtn.on("click", function () {
			$header.toggleClass("header_active");
		});
	})();

	(function initHeaderSubmenu() {
		var $menu = $(".header-nav"),
			$menuItems = $menu.find(".menu-item-has-children"),
			$menuItemsLinks = $menuItems.find(".header-nav-link"),
			$submenu = $menuItems.find(".header-subnav");

		$menuItems.on("mouseenter", function (e) {
			$menuItems.removeClass("open");
			$(e.target).closest($menuItems).toggleClass("open");
		});
		$menuItems.on("mouseleave", function (e) {
			$menuItems.removeClass("open");
		});
	})();

	(function initScrollUp() {
		const $bodyHtml = $("body, html");

		$(".btn-scroll-to").on("click", function (event) {
			event.preventDefault();
			var el = $(this).attr("href");

			if ($(el).length) {
				var offsetEl = $(el).offset().top - 50;

				$bodyHtml.animate(
					{
						scrollTop: offsetEl,
					},
					400,
				);
			}
		});
	})();
});
